import cs from "classnames";
import React from "react";

import "./CheckboxGroup.css";

interface CheckboxGroupProps {
	direction?: "horizontal" | "vertical";
	columns?: number; // vertical only
}

export const CheckboxGroup: React.FunctionComponent<
	React.PropsWithChildren<CheckboxGroupProps>
> = ({ direction = "horizontal", columns = 1, children }) => (
	<div
		className={cs(
			"checkbox-group",
			`checkbox-group--${direction}`,
			`checkbox-group--${columns}`
		)}
	>
		{children}
	</div>
);

export const CheckboxGroupColumn: React.FunctionComponent<
	React.PropsWithChildren
> = ({ children }) => <div className="checkbox-group__column">{children}</div>;
